<template>
  <el-row>
    <el-col :span="24">
      <div class>
        <div class="head">
          <el-form ref="form" :model="searchForm" inline class="form" @submit.native.prevent>
            <el-form-item>
              <el-input
                placeholder="请输入关键字搜索"
                prefix-icon="el-icon-search"
                clearable
                @keyup.enter.native="seachTitle" 
                v-model="searchForm.strtitle"
              >
                <template slot="append">
                  <el-button type="color" @click="seachTitle">搜一下</el-button>
                </template>
              </el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-button @click="seachTitle" type="color">搜一下</el-button>
            </el-form-item>-->
          </el-form>
        </div>
        <div class="center">
          <div class="choose">
            <div class="top">
              <div class="line_box">
                <span class="line_box_left">技术领域：</span>
                <span
                  :class="[searchForm.strTechFieldEnum == '' ? 'isActiv' : '']"
                  @click="changeTech({ ID: '' })"
                >全部</span>
                <div :class="['line_box_right', openLineTech ? 'line_wrap' : '']">
                  <span
                    :class="[
                      searchForm.strTechFieldEnum == item.ID ? 'isActiv' : '',
                    ]"
                    v-for="(item, index) in TechFieldEnumArr"
                    :key="index"
                    @click="changeTech(item)"
                  >{{ item.Title }}</span>
                </div>
                <span
                  v-if="openLineTech"
                  style="cursor: pointer; margin-left: auto"
                  @click="openMoreTech"
                >
                  收起
                  <i class="el-icon-arrow-up" />
                </span>
                <span v-else style="cursor: pointer; margin-left: auto" @click="openMoreTech">
                  更多
                  <i class="el-icon-arrow-down" />
                </span>
              </div>
              <div class="line_box">
                <span class="line_box_left">技术预算：</span>
                <div :class="['line_box_right']">
                  <span
                    v-for="(item, index) in BudgetArr"
                    :key="'c' + index"
                    :class="[
                      searchForm.strBudgetary == item.ID ? 'isActiv' : '',
                    ]"
                    @click="changeBudget(item)"
                  >{{ item.Title }}</span>
                </div>
              </div>
              <div class="line_box">
                <span class="line_box_left">合作方式：</span>
                <div :class="['line_box_right']">
                  <span
                    v-for="(item, index) in CooperaArr"
                    :key="'o' + index"
                    :class="[
                      searchForm.strCooperaType == item.ID ? 'isActiv' : '',
                    ]"
                    @click="changeCooper(item)"
                  >{{ item.Title }}</span>
                </div>
              </div>
              <div class="line_box">
                <span class="line_box_left">需求类型：</span>
                <div :class="['line_box_right']">
                  <span
                    v-for="(item, index) in fruitArr"
                    :key="index"
                    :class="[
                      searchForm.strDemandType == item.ID ? 'isActiv' : '',
                    ]"
                    @click="changeNeed(item)"
                  >{{ item.Title }}</span>
                </div>
              </div>
              <div class="line_box">
                <span class="line_box_left">企业类型：</span>
                <span
                  :class="[searchForm.strEnterpriseType == '' ? 'isActiv' : '']"
                  @click="changeEnterprise({ ID: '' })"
                >全部</span>
                <div
                  :class="[
                    'line_box_right',
                    'spwidth',
                    openLineEnterprise ? 'line_wrap' : '',
                  ]"
                >
                  <span
                    v-for="(item, index) in EnterpriseArr"
                    :class="[
                      searchForm.strEnterpriseType == item.ID ? 'isActiv' : '',
                    ]"
                    :key="index"
                    @click="changeEnterprise(item)"
                  >{{ item.Title }}</span>
                </div>
                <span
                  v-if="openLineEnterprise"
                  style="cursor: pointer; margin-left: auto"
                  @click="openMoreEnterprise"
                >
                  收起
                  <i class="el-icon-arrow-up" />
                </span>
                <span v-else style="cursor: pointer; margin-left: auto" @click="openMoreEnterprise">
                  更多
                  <i class="el-icon-arrow-down" />
                </span>
              </div>
              <div class="line_box" v-if="showBand">
                <span class="line_box_left">发布有效期：</span>
                <div :class="['line_box_right']">
                  <span
                    v-for="(item, index) in pathArr"
                    :key="index"
                    :class="[
                      searchForm.strReleaseTime == item.ID ? 'isActiv' : '',
                    ]"
                    @click="changeTime(item)"
                  >{{ item.Title }}</span>
                </div>
              </div>
              <div class="line_box" v-if="showBand">
                <span class="line_box_left">区域:</span>
                <span
                  :class="[searchForm.strCountries == '' ? 'isActiv' : '']"
                  @click="changeArea({ CityId: '' })"
                >全部</span>
                <div
                  :class="[
                    'line_box_right',
                    'spwidth',
                    openLineArea ? 'line_wrap' : '',
                  ]"
                >
                  <span
                    v-for="item in prizeArr"
                    :class="[
                      searchForm.strCountries == item.CityId ? 'isActiv' : '',
                    ]"
                    :key="item.cityId"
                    @click="changeArea(item)"
                  >{{ item.Name }}</span>
                </div>
                <span
                  v-if="openLineArea"
                  style="cursor: pointer; margin-left: auto"
                  @click="openMoreArea"
                >
                  收起
                  <i class="el-icon-arrow-up" />
                </span>
                <span v-else style="cursor: pointer; margin-left: auto" @click="openMoreArea">
                  更多
                  <i class="el-icon-arrow-down" />
                </span>
              </div>
              <div class="line_box bigneed" v-if="showBand">
                <span
                  class="line_box_left bigneed_left"
                  style="
                    width: 7rem !important;
                    white-space: pre-line !important;
                    align-items: baseline;
                  "
                >揭榜制重大科技项目需求:</span>
                <div :class="['line_box_right']">
                  <span
                    v-for="(item, index) in LibrariesArr"
                    :key="index"
                    :class="[
                      searchForm.strIsDemand == item.ID ? 'isActiv' : '',
                    ]"
                    @click="changeBigNeed(item)"
                  >{{ item.Title }}</span>
                </div>
              </div>
            </div>
            <div class="botm" @click="openBand">
              <p v-if="showBand">
                收起
                <img src="../../../assets/library/chengguo/路径 869.png" alt />
              </p>
              <p v-else>
                展开
                <img
                  style="transform: rotateZ(-270deg)"
                  src="../../../assets/library/chengguo/路径 869.png"
                  alt
                />
              </p>
            </div>
          </div>
          <el-row>
            <el-col :span="18">
              <div class="sort_count" ref="basicInformation">
                <div class="left">
                  <span
                    :class="sortA == null ? 'sortActiv' : 'sortNotActiv'"
                    @click="recomSort(null)"
                  >综合排序</span>
                  <div class="left_sort">
                    <div @click="timeSort(1)">
                      <span :class="sortA == 1 ? 'sortActiv' : 'sortNotActiv'">发布时间</span>
                      <img
                        :class="timeA ? 'fanzhuan' : ''"
                        src="../../../assets/library/排序 (1).png"
                        alt
                      />
                    </div>
                    <div @click="hotSort(2)">
                      <span :class="sortA == 2 ? 'sortActiv' : 'sortNotActiv'">热度</span>
                      <img
                        :class="hotA ? 'fanzhuan' : ''"
                        src="../../../assets/library/排序 (1).png"
                        alt
                      />
                    </div>
                    <div @click="moneySort(3)">
                      <span :class="sortA == 3 ? 'sortActiv' : 'sortNotActiv'">金额</span>
                      <img
                        :class="moneyA ? 'fanzhuan' : ''"
                        src="../../../assets/library/排序 (1).png"
                        alt
                      />
                    </div>
                  </div>
                </div>
                <div class="right">
                  <el-input placeholder="请输入关键字搜索" clearable @keyup.enter.native="seachTitle" v-model="searchForm.name">

                  </el-input>
                  <el-button @click="seachTitle" class="button" icon="el-icon-search"></el-button>
                </div>
              </div>
             
              <div class="card_box" v-if="cardArrList.length > 0">
               
                <div
                  class="card"
                  v-for="(item, index) in cardArrList"
                  :key="index"
                  @click="goDetail(item)"
                >
               
                 <img
                    v-if="item.isHot == 1"
                    class="hot"
                    src="../../../assets/library/chengguo/标签.png"
                    alt
                  /> 
                  <div class="card_img">
                    <img :src="item.PictureUrl" alt />
                  </div> 
                  <div class="card_text">
                    <div class="title">{{ item.Title }}</div>
                    <div class="small_title">
                      <p>单位名称：{{ item.UnitName }}</p>
                      <p>技术领域：{{ item.FieldName }}</p>
                    </div>
                    <div class="small_title">
                      <p>更新时间：{{ item.UpdateTime }}</p>
                    </div>
                    <p class="text_content">{{ item.Content }}</p>
                    <div class="text_img">
                     <div class="xing_wrap">
                        <div class="huang" v-for="i of item.Upload" :key="i">
                          <img src="../../../assets/library/chengguo/星星.png" alt />
                        </div> 
                         <div class="hui" v-for="i of 5 - item.Upload" :key="i">
                          <img src="../../../assets/library/chengguo/星星(1).png" alt />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card_money">
                    <p class="top">预算资金（万元）：</p>
                    <p class="botm" style="font-size: 20px;" v-if="item.InvestmentAmount && item.InvestmentAmount !== '0'">
                      <span>￥</span>
                      {{ item.InvestmentAmount }}
                    </p>
                    <p class="botm" v-else>
                      <span></span>面议
                    </p>
                  </div>
                </div>
                
              </div>
              <Empty v-else /> 
            </el-col>
            <el-col :span="6">
              <div class="hot_box">
                <div class="hot_person">
                  <div class="hot_person_top">
                    <div class="left">
                      <img src="../../../assets/library/chengguo/蒙版组 124.png" alt />
                      <span>&nbsp;热门专家</span>
                    </div>
                    <span class="right" @click="goTalent">
                      更多
                      <i class="el-icon-arrow-right" />
                    </span>
                  </div>
                  <div class="hot_person_center">
                    <div class="center_box" v-for="(v, i) in hotPersonCard" :key="i">
                      <div class="clc-lia" @click="goTalentDetail(v)">
                        <div class="clc-lia-name">
                          <div class="clcime">
                            <img v-if="v.Sex == 0" src="../../../assets/library/蒙版组 125.png" alt />
                            <img v-else src="../../../assets/library/蒙版组 125@2x.png" alt />
                          </div>
                          <div class="fullName">
                            <b>{{ v.FullName }}</b>
                          </div>
                          <div class="TechnicalPosition">{{ v.TechnicalPosition }}</div>
                        </div>
                      </div>
                      <div class="center_box_text">
                        <div class="text_top" @click="goTalentDetail(v)">{{ v.University }}</div>
                        <div class="text_line">
                          <span>{{ v.Direction[0] }}</span>
                          <!-- <p>|</p> -->
                          <span>{{ v.Direction[1] }}</span>
                        </div>
                        <el-button v-if="v.iscollection == 0" @click="follow(v)">+关注</el-button>
                        <el-button v-else @click="follow(v)">已关注</el-button>
                      </div>
                    </div>
                  </div>
                  <div class="hot_person_botm">
                    <div class="tab_head">
                      <div @click="cutCount">
                        <img src="../../../assets/library/chengguo/组 3543.png" alt />
                      </div>
                      <div class="head_box">
                        <div
                          :class="[
                            'head_img',
                            hpIsActiva == i + 1 ? 'head_img_IsActiva' : '',
                          ]"
                          v-for="(v, i) in hotPersonArr"
                          :key="i"
                          @click="chooseHead(i)"
                        >
                          <img src="../../../assets/library/蒙版组 125.png" alt />
                        </div>
                      </div>
                      <div @click="addCount">
                        <img src="../../../assets/library/chengguo/路径 869.png" alt />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="hot_comp">
                  <div class="hot_comp_top">
                    <div class="left">
                      <img src="../../../assets/library/chengguo/蒙版组 124.png" alt />
                      <span>&nbsp;热门机构</span>
                    </div>
                    <span class="right" @click="goOrgan()">
                      更多
                      <i class="el-icon-arrow-right" />
                    </span>
                  </div>
                  <div
                    class="hot_comp_card"
                    v-for="(item, index) in hotCompArr"
                    :key="index"
                    @click="goOrganDetail(item)"
                  >
                    <div class="card_Img">
                      <img :src="item.Url" alt />
                    </div>
                    <div class="card_text">
                      <p class="title">{{ item.UnitName }}</p>
                      <p class="xingzhi">
                        单位性质：
                        <span>{{ item.UnitType }}</span>
                      </p>
                      <p class="techarea">
                        技术领域：
                        <span>{{ item.TechnicalField }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- 分页 -->
          <Pagination
            :limit.sync="searchForm.size"
            :page.sync="searchForm.page"
            :total="total"
            @pagination="getCardData"
          />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { getAction, postAction } from '@/api/api'
import Pagination from '../components/Pagination/index.vue'

import qs from 'qs'
import {
  demandChoose,
  pcapi,
  demandList,
  organPool,
  hotperson,
  library,
  InnovativeTalentsHandle,
} from '@/api/url'
import { scrollTo } from '../components/Pagination/scroll-to' // 滚动方法
import Empty from '../../../components/empty.vue'

export default {
  name: 'demandSchool',
  comments: { Empty },
  data() {
    return {
      showBand: false,
      total: 2,
      searchForm: {
        action: 'GetCollegesDemandPageList',
        // action: 'Demand_BindList',
        id: this.$route.query.sid,
        limit: 10, //一页多少条
        page: 1, //	第几页
        strTechFieldEnum: '', //	技术领域id
        strBudgetary: '', //	技术预算id
        strCooperaType: '', //	合作方式id
        strReleaseTime: '', // 发布有效期
        strEnterpriseType: '', // 企业类型
        strCountries: '', // 区域CityId
        strDemandType: '', // 	需求类型id
        strSort: '', //发布时间 上 a.UpdateTime ASC //发布时间 下 a.UpdateTime DESC //热度 上 a.ClickRank ASC //热度 下 a.ClickRank DESC //金额 上 a.InvestmentAmount ASC //金额 下 a.InvestmentAmount DESC
        strtitle: '', // 	搜索关键字
        strIsDemand: '', // 	揭榜制重大科技项目需求 键值对中的key 数字
      },
      TechFieldEnumArr: [
        // {
        //   ID: "",
        //   Title: "全部",
        // },
      ],
      openLineTech: false, // 技术展开
      openLineKonw: false,
      prizeArr: [],
      fruitArr: [
        {
          ID: '',
          Title: '全部',
        },
      ],
      pathArr: [
        {
          ID: '',
          Title: '全部',
        },
      ],
      CooperaArr: [
        {
          ID: '',
          Title: '全部',
        },
      ],
      BudgetArr: [
        {
          ID: '',
          Title: '全部',
        },
      ],
      LibrariesArr: [
        {
          ID: '',
          Title: '全部',
        },
        {
          ID: '0',
          Title: '申请中的项目',
        },
        {
          ID: '1',
          Title: '已通过的项目',
        },
      ],
      openLineEnterprise: false,
      openLineArea: false,
      EnterpriseArr: [
        // {
        //   ID: "",
        //   Title: "全部",
        // },
        {
          ID: '0',
          Title: '科技型企业',
        },
        {
          ID: '1',
          Title: '高新技术企业',
        },
        {
          ID: '创新龙头企业',
          Title: '创新龙头企业',
        },
        {
          ID: '瞪羚企业',
          Title: '瞪羚企业',
        },
        {
          ID: '独角兽企业',
          Title: '独角兽企业',
        },
        {
          ID: '工程技术研究中心',
          Title: '工程技术研究中心',
        },
        {
          ID: '国家重点实验室',
          Title: '国家重点实验室',
        },
        {
          ID: '技术创新示范企业',
          Title: '技术创新示范企业',
        },
        {
          ID: '技术先进型服务企业',
          Title: '技术先进型服务企业',
        },
        {
          ID: '节能减排科技创新示范企业',
          Title: '节能减排科技创新示范企业',
        },
        {
          ID: '科技企业孵化器',
          Title: '科技企业孵化器',
        },
        {
          ID: '绿色示范工厂',
          Title: '绿色示范工厂',
        },
        {
          ID: '省级国际联合实验室',
          Title: '省级国际联合实验室',
        },
        {
          ID: '十百千技术改造示范工程',
          Title: '十百千技术改造示范工程',
        },
        {
          ID: '院士工作站',
          Title: '院士工作站',
        },
        {
          ID: '制造业单项冠军示范企业',
          Title: '制造业单项冠军示范企业',
        },
        {
          ID: '质量标杆',
          Title: '质量标杆',
        },
      ],
      CountriesArr: [
        {
          ID: '',
          Title: '全部',
        },
        {
          ID: '0',
          Title: '国内',
        },
        {
          ID: '1',
          Title: '国外',
        },
      ],
      provinceArr: [],
      cityArr: [],
      countryArr: [],
      sortA: null, //综合排序
      hotA: false, // 热度排序
      timeA: false, // 热度排序
      moneyA: false, // 金额排序
      cardArrList: [], // 卡片内容
      hotPersonArr: [], // 热门专家
      hpIsActiva: 1, // 专家激活
      hotPersonCard: [], // 热门专家卡
      hotCompArr: [], // 热门公司
    }
  },
  props: {},
  components: {
    Pagination,
    Empty,
  },
  created() {
    console.log(this.$route.query.sid,'匹配需求点击查看更多this.$route.query.sid')
    this.$bus.$emit('ChangeFocus', 2)
    window.localStorage.setItem('NowIndex', 2)
    if (this.$route.query.id) {
      this.searchForm.strTechFieldEnum = this.$route.query.id
    }
    this.getCardData()
    
  },
  mounted() {
    this.getChoose()
    this.searchForm.strSort = 'a.UpdateTime DESC'
    
    // this.changeCountr({ ID: "" });
    this.getHotPerson()
    this.getHotcompData()
    this.$bus.$on('LoginSuccess', (e) => {
      //// console.log(e);
      if (e) {
        setTimeout(() => {
          this.getCardData()
          this.getHotPerson()
          this.getHotcompData()
        }, 300)
      }
    })
  },
  methods: {
    // 关注专家
    follow(a) {
      let RealID = localStorage.getItem('RealID')
      if (!RealID == '') {
        let data = {
          action: 'Collection_Items',
          UserID: localStorage.getItem('RealID'),
          ProjectID: a.id,
          Type: 3,
        }
        postAction(library, qs.stringify(data)).then((res) => {
          //// console.log(res);
          if (res.status == 'y') {
            this.$message.success('关注成功！')
            this.getHotPerson()
          } else {
            this.$message.success('取消关注')
            this.getHotPerson()
          }
        })
      } else {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      }
    },
    // //登陆成功
    // LoginSuccess() {
    //   let data = {
    //     action: "Get_UserInfo",
    //   };
    //   postAction(library, this.$qs.stringify(data)).then((res) => {
    //     this.RealName = res.RealName;
    //     localStorage.setItem("RealName", res.RealName);
    //     localStorage.setItem("RealID", res.ID);
    //   });
    // },
    // 跳转机构库
    goOrgan() {
      const { href } = this.$router.resolve('/Organization')
      window.open(href, '_blank')
    },
    // 跳转机构库详情
    goOrganDetail(item) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
      let flag = true
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false
          break
        }
      }
      if (window.screen.width >= 768) {
        flag = true
      }
      //// console.log(item)
      if (flag) {
        const { href } = this.$router.resolve({
          path: '/OrganizationDetail',
          query: {
            id: item.ID,
            type: item.Type,
          },
        })
        window.open(href, '_blank')
      } else {
        this.$router.push({
          path:
          this.Urls+ '/Mobile/index.html#/OrganPoolDetail?id=' +
            item.ID +
            '&strType=' +
            item.Type,
        })
      }
    },
    // 跳转人才
    goTalent() {
      const { href } = this.$router.resolve('/talent')
      window.open(href, '_blank')
    },
    // 跳转人才详情
    goTalentDetail(item) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
      let flag = true
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false
          break
        }
      }
      if (window.screen.width >= 768) {
        flag = true
      }
      if (flag) {
        const { href } = this.$router.resolve({
          path: '/talentPoolinfo',
          query: {
            list: item.id,
          },
        })
        window.open(href, '_blank')
      } else {
         window.location.href=this.Urls+'/Mobile/index.html#/TalentPoolDetail?id=' +
           item.id
        // this.$router.push({
        //   path:
        //     'http://www.nttzzc.com/Mobile/index.html#/TalentPoolDetail?id=' +
        //     item.id,
        // })
      }
    },
    // 跳转详情页
    goDetail(a) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
      let flag = true
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false
          break
        }
      }
      if (window.screen.width >= 768) {
        flag = true
      }
      if (flag) {
        //// console.log(a);
        const { href } = this.$router.resolve({
          path: '/demandDetail',
          query: {
            id: a.ID,
          },
        })
        window.open(href, '_blank')
      } else {
         window.location.href=this.Urls+'/Mobile/index.html#/NeedPoolDetail?id=' +
           a.ID
        // this.$router.push({
        //   path:
        //     'http://www.nttzzc.com/Mobile/index.html#/NeedPoolDetail?id=' +
        //     a.ID,
        // })
      }
    },
    getChoose() {
      this.getTechFieldEnum()
      this.getDemand()
      this.getTime()
      this.getCoopera()
      this.getBudget()
      this.getArea()
    },
    // 技术领域
    getTechFieldEnum() {
      let data = {
        action: 'Demand_getfields',
        ParentName: 'TechFieldEnum',
      }
      getAction(demandChoose, data).then((res) => {
        // console.log(res)
        res.map((item) => {
          this.TechFieldEnumArr.push(item)
        })
      })
    },
    // 获取区域
    getArea() {
      let data = {
        action: 'Get_CityList',
      }
      getAction(demandChoose, data).then((res) => {
        //// console.log(res);
        res.map((item) => {
          this.prizeArr.push(item)
        })
        //// console.log(this.prizeArr);
      })
    },
    // 需求类型
    getDemand() {
      let data = {
        action: 'Demand_getfields',
        ParentName: 'DemandType',
      }
      getAction(demandChoose, data).then((res) => {
        res.map((item) => {
          this.fruitArr.push(item)
        })
      })
    },
    // 需求有效期
    getTime() {
      let data = {
        action: 'Demand_getfields',
        ParentName: 'ReleaseTime',
      }
      getAction(demandChoose, data).then((res) => {
        res.map((item) => {
          this.pathArr.push(item)
        })
      })
    },
    // 合作方式
    getCoopera() {
      let data = {
        action: 'Demand_getfields',
        ParentName: 'CooperaType',
      }
      getAction(demandChoose, data).then((res) => {
        res.map((item) => {
          this.CooperaArr.push(item)
        })
      })
    },
    // 预算
    getBudget() {
      let data = {
        action: 'Demand_getfields',
        ParentName: 'Budgetary',
      }
      getAction(demandChoose, data).then((res) => {
        // console.log('预算预算',res)
        res.map((item) => {
          this.BudgetArr.push(item)
        })
      })
    },
   async getCardData() {
    
    let res = await getAction(InnovativeTalentsHandle, this.searchForm);  
    if (Array.isArray(res.data)) {  
      console.log(res.data, 'res');  
      res.data.map((item) => {
          if (item.Upload == 'A') {
            item.Upload = 5
          } else if (item.Upload == 'B') {
            item.Upload = 4
          } else if (item.Upload == 'C') {
            item.Upload = 3
          } else if (item.Upload == 'D') {
            item.Upload = 2
          } else if (item.Upload == 'E') {
            item.Upload = 1
          }
        })
      console.log(this.cardArrList, 'cardArrList');  
      // this.cardArrList.push({})
      this.cardArrList = res.data;  
      console.log(this.cardArrList, 'cardArrList');  
      // this.total = res.count; // 确保 res.count 也是有效的  
    } else {  
      console.error('res.data is not an array:', res.data);  
      // 处理错误情况，比如设置默认值或抛出异常  
    }  
 
    }, // 卡片内容
    seachTitle() {
      this.$refs.basicInformation.scrollIntoView({
			behavior: "smooth",  // 平滑过渡
			block: "start"  	// 上边框与视窗顶部平齐。默认值
		});
      this.searchForm.page = 1
      this.getCardData()
    }, // 头部搜索
    recomSort(a) {
      this.searchForm.page = 1
      this.sortA = a
      this.hotA = false
      this.timeA = false
      this.moneyA = false
      this.searchForm.strSort = ''
      this.getCardData()
    }, // 综合排序
    timeSort(a) {
      this.searchForm.page = 1
      this.timeA = !this.timeA
      this.sortA = a
      this.hotA = false
      this.moneyA = false
      if (this.timeA == true) {
        this.searchForm.strSort = 'a.UpdateTime ASC'
        this.getCardData()
      } else {
        this.searchForm.strSort = 'a.UpdateTime DESC'
        this.getCardData()
      }
    }, //时间排序
    hotSort(a) {
      this.searchForm.page = 1
      this.hotA = !this.hotA
      this.sortA = a
      this.timeA = false
      this.moneyA = false
      if (this.hotA == true) {
        this.searchForm.strSort = 'a.ClickRank ASC'
        this.getCardData()
      } else {
        this.searchForm.strSort = 'a.ClickRank DESC'
        this.getCardData()
      }
    }, // 热度排序
    moneySort(a) {
      this.searchForm.page = 1
      this.moneyA = !this.moneyA
      this.sortA = a
      this.hotA = false
      this.timeA = false
      if (this.moneyA == true) {
        this.searchForm.strSort = 'a.InvestmentAmount ASC'
        this.getCardData()
      } else {
        this.searchForm.strSort = 'a.InvestmentAmount DESC'
        this.getCardData()
      }
    }, // 金额排序
    // 切换计划标签
    changeTech(item) {
      this.searchForm.strTechFieldEnum = item.ID
      this.searchForm.page = 1
      this.getCardData()
    },
    // 技术更多
    openMoreTech() {
      this.openLineTech = !this.openLineTech
    },
    openMoreKonw() {
      this.openLineKonw = !this.openLineKonw
    },
    changeArea(item) {
      //// console.log(item, "区域");
      this.searchForm.strCountries = item.CityId
      this.searchForm.page = 1
      this.getCardData()
    },
    changeNeed(item) {
      this.searchForm.strDemandType = item.ID
      this.searchForm.page = 1
      this.getCardData()
    },
    changeTime(item) {
      this.searchForm.strReleaseTime = item.ID
      this.searchForm.page = 1
      this.getCardData()
    },
    changeCooper(item) {
      this.searchForm.strCooperaType = item.ID
      this.searchForm.page = 1
      this.getCardData()
    },
    changeBudget(item) {
      this.searchForm.strBudgetary = item.ID
      this.searchForm.page = 1
      this.getCardData()
    },
    changeBigNeed(item) {
      this.searchForm.strIsDemand = item.ID
      this.searchForm.page = 1
      this.getCardData()
    },
    openMoreEnterprise() {
      this.openLineEnterprise = !this.openLineEnterprise
    },
    openMoreArea() {
      this.openLineArea = !this.openLineArea
    },
    changeEnterprise(item) {
      this.searchForm.strEnterpriseType = item.ID
      //// console.log(this.searchForm.strEnterpriseType, item.ID);
      this.searchForm.page = 1
      this.getCardData()
    },
    chooseCity() {
      this.getCardData()
    },
    chooseCountry() {
      this.getCardData()
    },
    openBand() {
      this.showBand = !this.showBand
    },
    getHotPerson() {
      let data = {
        action: 'HotExpertsList',
        PageIndex: 1,
        pageSize: 5,
        userid: localStorage.getItem('RealID'),
      }
      getAction(hotperson, data).then((res) => {
        //// console.log(res);
        this.hotPersonArr = res.list
        this.hotPersonCard = []
        this.hotPersonArr.map((item, index) => {
          if (index + 1 == this.hpIsActiva) {
            if (typeof item.Direction == 'string') {
              item.Direction = item.Direction.split('|')
            }
            this.hotPersonCard.push(item)
          }
        })
      })
    },
    cutCount() {
      if (this.hpIsActiva > 1) {
        this.hotPersonCard = []
        this.hpIsActiva = --this.hpIsActiva
        this.hotPersonArr.map((item, index) => {
          if (index + 1 == this.hpIsActiva) {
            if (typeof item.Direction == 'string') {
              item.Direction = item.Direction.split('|')
            }
            this.hotPersonCard.push(item)
          }
        })
        // //// console.log(this.hotPersonCard);
        // this.hotPersonCard[0].Direction =
        //   this.hotPersonCard[0].Direction.split("|");
      } else {
        return false
      }
      //// console.log(this.hpIsActiva);
    },
    addCount() {
      if (this.hpIsActiva < 5) {
        this.hotPersonCard = []
        this.hpIsActiva = ++this.hpIsActiva
        this.hotPersonArr.map((item, index) => {
          if (this.hpIsActiva == index + 1) {
            if (typeof item.Direction == 'string') {
              item.Direction = item.Direction.split('|')
            }
            this.hotPersonCard.push(item)
          }
        })
        // //// console.log(this.hotPersonCard);
        // this.hotPersonCard[0].Direction =
        //   this.hotPersonCard[0].Direction.split("|");
      } else {
        return false
      }
    },
    chooseHead(a) {
      this.hpIsActiva = a + 1
      //// console.log(this.hpIsActiva);
      if (typeof this.hotPersonArr[a].Direction == 'string') {
        this.hotPersonArr[a].Direction =
          this.hotPersonArr[a].Direction.split('|')
      }
      this.hotPersonCard[0] = this.hotPersonArr[a]
      //// console.log(this.hotPersonCard);
    },
    getHotcompData() {
      let data = {
        action: 'Random_List',
        row: 2,
      }
      postAction(organPool, qs.stringify(data)).then((res) => {
        //// console.log(res);
        this.hotCompArr = res
      })
    },
  },
}
</script>

<style lang="scss" scoped>
// .isActiv {
//   height: 1.875rem;
//   background: #2769dc;
//   opacity: 1;
//   color: #ffffff;
//   border-radius: 0.3125rem;
//   padding: 0 0.3125rem;
// }
.head {
  width: 100%;
  height: 21.875rem;
  background-image: url('../../../assets/library/chengguo/组 3826.png');
  background-size: 100% 21.875rem;
}
.form {
  width: 45rem;
  height: 4rem;
  margin: 0 auto;
  padding-top: 5.75rem;
  .el-input {
    width: 37.25rem;
    /deep/.el-input__inner {
      height: 4rem !important;
      padding-left: 3.5rem;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      opacity: 1;
    }
    /deep/ .el-input__prefix {
      left: 1.25rem;
      .el-input__icon {
        font-size: 1.25rem;
        height: 4.5rem;
      }
    }
    /deep/ .el-input-group__append {
      border: none;
    }
    .el-button--color {
      background: #2769dc;
      border: none;
      widows: 7.75rem;
      height: 4rem;
      border-radius: 0;
      ::v-deep span {
        font-size: 1.25rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 0rem;
        color: #ffffff;
        opacity: 1;
      }
    }
  }
}
::v-deep .el-form-item {
  margin-right: 0 !important;
}
/deep/ .btn-prev,
.btn-next {
  background-color: #fff !important;
}

.center {
  transform: translateY(-5.75rem);
  width: 87.5rem;
  margin: 0 auto;
}

.choose {
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  // height: 40.375rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  opacity: 1;
  padding: 2.0625rem 1.625rem;
  .top {
    .line_box {
      /* margin-bottom: 1.9375rem; */
      margin-bottom: 1.25rem;
      display: flex;
      align-items: baseline;
      .bigneed {
        align-items: center;
      }
      .line_box_left {
        min-width: 7rem;
        text-align: left;
        white-space: pre-line;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #4a4a4a;
        opacity: 1;
      }
      .line_box_right {
        // margin-left: 0.8125rem;
        display: flex;
        flex-wrap: wrap;
        // max-width: 64.125rem;
        width: 64.125rem;
        height: 2.4rem;
        overflow: hidden;
        flex: 1;
        span {
          white-space: nowrap;
          font-size: 1rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          opacity: 1;
          padding: 0.5rem 0.955rem;
          text-align: left;
          cursor: pointer;
        }
        .isActiv {
          cursor: pointer;
          background: #2769dc;
          opacity: 1;
          color: #ffffff;
          border-radius: 0.3125rem;
          line-height: auto;
          padding: 0.3125rem 0.955rem;
        }
      }
      span {
        white-space: nowrap;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        opacity: 1;
        padding: 0.375rem 1.125rem;
        text-align: left;
        // cursor: pointer;
      }
      .isActiv {
        cursor: pointer;
        background: #2769dc;
        opacity: 1;
        color: #ffffff;
        border-radius: 0.3125rem;
        line-height: 1.5625rem;
        padding: 0.375rem 1.125rem;
        height: 1.5625rem;
      }
      .spwidth {
        // max-width: 57.125rem !important;
        width: 57.125rem !important;
      }
      .line_wrap {
        height: auto;
      }
    }
  }
  .botm {
    p {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      opacity: 1;
      cursor: pointer;
      img {
        width: 0.4375rem;
        height: 0.75rem;
        transform: rotateZ(-90deg);
      }
    }
  }
}

.sort_count {
  display: flex;
  justify-content: space-between;
  height: 4.375rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  opacity: 1;
  margin-top: 1.875rem;
  align-items: center;
  padding: 0 1.625rem;
  .left {
    display: flex;
    .sortNotActiv {
      color: #999999 !important;
      cursor: pointer;
    }
    .sortActiv {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      opacity: 1;
      cursor: pointer;
    }
    .left_sort {
      display: flex;
      span {
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: normal;
        color: #333333;
        opacity: 1;
        cursor: pointer;
      }
      div {
        cursor: pointer;
        margin-left: 2.3125rem;
      }
      img {
        width: 0.5313rem;
        height: 0.75rem;
        margin-left: 0.5625rem;
      }
      .fanzhuan {
        transform: rotate(180deg);
      }
    }
  }
  .right {
    display: flex;

    .button {
      background: #2769dc !important;
      border: none;
      // margin-top: -2px;
      // margin-left: 14.3rem;
      // margin-left: 12rem;
      height: 2.5rem;
      border-radius: 0px;
      color: white;

    }
  }
}
.card_box {
  margin-top: 1.875rem;
  .card {
    cursor: pointer;
    background: #ffffff;
    box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
    opacity: 1;
    padding: 1.5rem;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 1.5rem;
    position: relative;
    &:hover {
      box-sizing: border-box;
      border: 1px solid #2769dc;
    }
    .hot {
      position: absolute;
      top: 0;
      left: 0;
    }
    .card_img {
      width: 22.25rem;
      height: 12.0625rem;
      opacity: 1;
      // background-color: red;
      img {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
      }
    }
    .card_text {
      width: 28.9375rem;
      // background-color: orange;
      margin-left: 1.5rem;
      margin-right: 2.1875rem;
      padding-right: 1.875rem;
      border-right: 0.0625rem dashed #d1d1d1;
      text-align: left;
      .title {
        font-size: 1.1875rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2769dc;
        opacity: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .small_title {
        // width: 14.4375rem;
        display: flex;
        justify-content: flex-start;
        margin-top: 0.875rem;
        margin-bottom: 1.125rem;
        p {
          width: 45%;
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          opacity: 1;
          margin-right: 0.625rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .text_content {
        width: 28.9375rem;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        opacity: 1;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .text_img {
        display: flex;
        margin-top: 1.375rem;
        .xing_wrap {
          display: flex;
          align-items: center;
          img {
            width: 1.5625rem;
            height: 1.5625rem;
            vertical-align: bottom;
            padding: 0 0.125rem;
          }
        }
        .pinggu {
          width: 5.3125rem;
          height: 1.875rem;
          margin-left: 0.3125rem;
          img {
            width: 100%;
            vertical-align: bottom;
          }
        }
      }
    }
    .card_money {
      height: initial;
      text-align: right;
      margin: 3.5rem 0 3.0313rem 0;
      .top {
        font-size: 0.875rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 1.875rem;
        color: #aaaaaa;
        opacity: 1;
        white-space: nowrap;
      }
      .botm {
        font-size: 1.8125rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 1.875rem;
        color: #f15916;
        opacity: 1;
        span {
          font-size: 0.875rem;
        }
      }
    }
  }
}
.hot_box {
  display: flex;
  flex-direction: column;
  // background-color: red;
  margin-left: 1.25rem;
  margin-top: 1.875rem;
  .hot_person {
    // height: 31.6875rem;
    // background-color: orange;
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
    .hot_person_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        img {
          width: 2rem;
          height: 2rem;
          vertical-align: bottom;
        }
        span {
          font-size: 1.5rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          opacity: 1;
        }
      }
      .right {
        cursor: pointer;
        font-size: 1.125rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 1.75rem;
        color: #999999;
        opacity: 1;
      }
    }
    .hot_person_center {
      width: 17.8125rem;
      height: 21.3125rem;
      border: 0.0625rem solid #e4e4e4;
      margin-top: 1.3125rem;
      padding-bottom: 1.5rem;
      cursor: pointer;
      .center_box {
        margin: 0 1.25rem;
        .clc-lia-name {
          padding: 2.5rem 1.5rem;
          background: #f7f7f7;
          margin-top: 4.25rem;
          text-align: left;
          box-sizing: border-box;
          position: relative;
          width: 12rem;
          .clcime {
            position: absolute;
            bottom: 0;
            right: -3.9375rem;
            width: 8.75rem;
            height: 8.75rem;
            background: #fff;
            border-radius: 50%;
            img {
              width: 8.0625rem;
              height: 8.0625rem;
              z-index: 10;
              margin: 0.25rem 0.25rem 0;
            }
          }

          .fullName {
            b {
              font-size: 1rem;
            }
          }
          .TechnicalPosition {
            color: #999;
          }
        }
        .clc-lia-name::before {
          content: '';
          display: block;
          width: 0.1875rem;
          height: 50%;
          position: absolute;
          top: 50%;
          left: 0rem;
          transform: translateY(-50%);
          background: #0561d2;
        }
        .center_box_text {
          margin-top: 2.0625rem;
          /deep/ .el-button {
            padding: 0;
          }
          .text_top {
            margin-bottom: 0.75rem;
            font-size: 1rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;
            opacity: 1;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          .text_line {
            margin-bottom: 0.625rem;
            font-size: 0.875rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: 1.875rem;
            color: #999999;
            opacity: 1;
            display: flex;
            span {
              width: 45%;
              padding: 0 0.1875rem;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
              text-align: right;
            }
          }
          /deep/ .el-button {
            width: 6.3125rem;
            height: 2.1875rem;
            background: #2769dc;
            opacity: 1;
            border-radius: 0.25rem;
            i {
              color: #fff;
            }
            span {
              font-size: 0.875rem;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #ffffff;
              opacity: 1;
            }
          }
        }
      }
    }
    .hot_person_botm {
      width: 100%;
      margin-top: 2.5rem;
      .tab_head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          cursor: pointer;
        }
        .head_box {
          width: 100%;
          height: 2.5rem;
          display: flex;
          justify-content: flex-start;
          .head_img {
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
            border: 0.125rem solid #308bec;
            margin-left: 0.4688rem;
            overflow: hidden;
            opacity: 0.4;
            cursor: pointer;
            img {
              width: 80%;
              height: 100%;
              vertical-align: bottom;
              cursor: pointer;
            }
          }
          .head_img_IsActiva {
            opacity: 1;
          }
        }
      }
    }
  }
  .hot_comp {
    margin-top: 1.875rem;
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
    .hot_comp_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        img {
          width: 2rem;
          height: 2rem;
          vertical-align: bottom;
        }
        span {
          font-size: 1.5rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          opacity: 1;
        }
      }
      .right {
        cursor: pointer;
        font-size: 1.125rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 1.75rem;
        color: #999999;
        opacity: 1;
      }
    }
    .hot_comp_card {
      width: 17.875rem;
      height: 16.75rem;
      background: #ffffff;
      border: 0.0625rem solid #e4e4e4;
      opacity: 1;
      border-radius: 0rem;
      margin-top: 1.5625rem;
      cursor: pointer;
      .card_Img {
        width: 100%;
        // height: 9.6875rem;
        img {
          width: 100%;
          // height: 100%;
          vertical-align: top;
        }
      }
      .card_text {
        text-align: left;
        padding: 1rem;
        .title {
          font-size: 1rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 1.625rem;
          color: #333333;
          opacity: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .xingzhi {
          width: 12.5rem;
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 1.625rem;
          color: #d0d0d0;
          opacity: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span {
            color: #8b8b8b;
          }
        }
        .techarea {
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 1.625rem;
          color: #d0d0d0;
          opacity: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          span {
            color: #8b8b8b;
          }
        }
      }
    }
  }
}
.isActiv {
  cursor: pointer;
  background: #2769dc;
  opacity: 1;
  color: #ffffff;
  border-radius: 0.3125rem;
  line-height: 1.5625rem;
  padding: 0.3125rem 0.96rem !important;
  height: 1.5625rem;
}
</style>